import { render, staticRenderFns } from "./PelatihanSubCategory.vue?vue&type=template&id=424c739b"
import script from "./PelatihanSubCategory.vue?vue&type=script&lang=js"
export * from "./PelatihanSubCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports